import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'find'
})
export class FindPipe implements PipeTransform {
  transform<T>(array: T[], field: keyof T, value: any): T | undefined {
    if (!Array.isArray(array) || !field) return undefined;
    return array.find(item => item[field] === value);
  }
}
